import { network } from 'services/network';

export const privilegeList = () => {
    return network.get('admin/bo/privilegeList').then((response) => {
        return response.data;
    });
};
